import axios from 'axios';
// import { message } from 'antd';

const API_BASE_URL = 'https://api-dev.mymoliapp.com'; 

class MoliAPICall {
  constructor(token) {
    this.api = axios.create({
      baseURL: API_BASE_URL,
      headers: {
        'Authorization': "vgeLOrXQG4CqWoleIKS9GhIwSNbCwwdY", // Include Authorization header with Bearer token
        'Content-Type': 'application/json', // Specify content type as JSON
        'Accept': 'application/json', // Accept JSON responses
      }
    });
  }
  // async showSuccessMessage(msg) {
  //   message.success(msg, 3);
  // }

  // async showErrorMessage(msg) {
  //   message.error(msg, 3);
  // }

  async globalAPICAll(endPoint, method = "get", payload = {}) {
    try {
      let response;
      if (method === "get") {
        response = await this.api.get(endPoint);
      } else if (method === "post") {
        response = await this.api.post(endPoint, payload);
      } else if (method === "delete") {
        response = await this.api.delete(endPoint);
      } else if (method === "patch") {
        response = await this.api.patch(endPoint, payload);
      } else if (method === "put") {
        response = await this.api.put(endPoint, payload);
      }
      const data = response.data
      // if( method !== 'get' ){
      //   message.success(data.msg)
      // }
      return data
    } catch (error) {
        try {
          if (error.response) {
            this.showErrorMessage(error.response.data.detail);
          }
        } catch (error) {
          this.showErrorMessage("Error fetching data");
        }
    }
  }

  async fetchJobData(jobId) {
    const endpoint = `/api/GetJobByJobId?job_id=${jobId}`;
    return this.globalAPICAll(endpoint, "get");
  }
}

export default MoliAPICall;
